import {handleLogout} from "components/utils"; import React, {useEffect, useState} from 'react';
import axios from "axios";
import {Col, Nav, Row, Tab, Tabs} from "react-bootstrap";
import {BILLING, hasInternalPermissions, RADIOLOGY} from "../../permissions";
import {useCookies} from "react-cookie";
import {PendingReportsView} from "../PendingReportsView";
import {MedicalServicesView} from "../../inventory/services/MedicalServicesView";

export const RadiologyView = (props: { cookieEntityQr: string }) => {

    const [doctors, setDoctors] = useState<Array<any>>([])
    const [radiologyEnabled, setRadiologyEnabled] = useState(true)
    const [cookies] = useCookies(['qme']);

    useEffect(() => {
        // Perform localStorage action
        setRadiologyEnabled(localStorage.getItem('radiology') == "true")
    }, [])

    function loadEntityData() {
        axios.get('/api/backend/entity/profile/' + props.cookieEntityQr)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setDoctors(resp.data.clientProfileEntities)
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    useEffect(() => {
        if (props.cookieEntityQr) {
            loadEntityData();
        }
    }, [props.cookieEntityQr])

    return (
        <>
            {radiologyEnabled &&
                <>
                    < div className="d-lg-none">
                        <Tabs
                            defaultActiveKey="tests"
                            className="my-3 fs-6 text-secondary nav-pills tabs"
                        >
                            {(hasInternalPermissions(cookies.qme, RADIOLOGY)) &&
                                <Tab eventKey="tests" title="&#129534; Tests">
                                    <PendingReportsView cookieEntityQr={props.cookieEntityQr} category="RADIOLOGY"/>
                                </Tab>}
                            {(hasInternalPermissions(cookies.qme, RADIOLOGY)) &&
                                <Tab eventKey="rates" title="&#129534; Rates">
                                    <MedicalServicesView cookieEntityQr={props.cookieEntityQr} category={"Radiology"}/>
                                </Tab>}
                        </Tabs>
                    </div>
                    <div className="d-none d-lg-block left-tabs">
                        <Col>
                            <Tab.Container id="left-tabs" defaultActiveKey="tests">
                                <Row className="justify-content-center">
                                    <Col sm={2} className="sidebar-menu">
                                        <Nav variant="pills" className="flex-column">
                                            {(hasInternalPermissions(cookies.qme, RADIOLOGY)) &&
                                                <Nav.Item>
                                                    <Nav.Link eventKey="tests">Tests</Nav.Link>
                                                </Nav.Item>}
                                            {(hasInternalPermissions(cookies.qme, RADIOLOGY)) &&
                                                <Nav.Item>
                                                    <Nav.Link eventKey="rates">Rates</Nav.Link>
                                                </Nav.Item>}
                                        </Nav>
                                    </Col>
                                    <Col sm={10}>
                                        <Tab.Content>
                                            {(hasInternalPermissions(cookies.qme, RADIOLOGY)) &&
                                                <Tab.Pane eventKey="tests">
                                                    <PendingReportsView cookieEntityQr={props.cookieEntityQr} category="RADIOLOGY"/>
                                                </Tab.Pane>}
                                        </Tab.Content>
                                        <Tab.Content>
                                            {(hasInternalPermissions(cookies.qme, RADIOLOGY)) &&
                                                <Tab.Pane eventKey="rates">
                                                    <MedicalServicesView cookieEntityQr={props.cookieEntityQr} category={"Radiology"}/>
                                                </Tab.Pane>}
                                        </Tab.Content>
                                    </Col>
                                </Row>
                            </Tab.Container>
                        </Col>
                    </div>
                </>
            }
            {!radiologyEnabled &&
                <div className="fs-3 text-secondary text-center py-5">Licence not available for this module.</div>
            }
        </>
    );
};

